import React, { useEffect, useRef } from "react";
import { HEREWEARE_APP_STORE_URL, HEREWEARE_PLAY_STORE_URL, HEREWEARE_QR_PATH } from "../../sites/home/utils/install";
import "./InstallModal.css";

export function InstallModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;

    const previousFocus = document.activeElement as HTMLElement | null;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
      // 모달 내부 포커스 순환 및 닫힌 후 진입 버튼 복귀
      if (event.key === "Tab") {
        const items = closeButtonRef.current?.closest("section")?.querySelectorAll<HTMLElement>("button, a[href]");
        if (!items?.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [open, onClose]);

  return (<>
      {open && (
        <div
          className="install-modal"
          role="presentation"
          onMouseDown={(event) =>
            event.target === event.currentTarget && onClose()
          }
        >
          <section
            className="install-modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="install-modal-title"
          >
            <button
              ref={closeButtonRef}
              type="button"
              className="install-modal__close"
              aria-label="Close app installation dialog"
              onClick={onClose}
            >
              ×
            </button>
            <div className="install-modal__copy">
              <span>HEREWEARE APP</span>
              <p id="install-modal-title">Scan the QR code to install HereWeAre.</p>
            </div>
            <a
              className="install-modal__qr"
              href={HEREWEARE_QR_PATH}
              target="_blank"
              rel="noreferrer"
              aria-label="Open the HereWeAre installation page"
            >
              <img
                src="/assets/img/hereweare-install-qr.png"
                alt="QR code to install HereWeAre"
              />
            </a>
            <div className="install-modal__stores">
              <a
                href={HEREWEARE_APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                App Store
              </a>
              <a
                href={HEREWEARE_PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                Google Play
              </a>
            </div>
          </section>
        </div>
      )}
  </>);
}
